import React, {
  CSSProperties,
  forwardRef,
  RefObject,
  SyntheticEvent,
  useCallback,
  useContext,
} from 'react'

import { cx } from '@linaria/core'
import { Link } from 'react-router-dom'

import { ProfileNextContext } from 'components/block/Profile/ProfileMain/context/ProfileNextContext'
import { HeartSvg } from 'components/designSystem/svgr/HeartSvg'
import { Direction } from 'components/page/RatingWave/Rating.types'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useAuthorized } from 'hooks/useAuthorized'

import { activeCss, commonCss } from './buttons.styled'
import { iconProps } from './constants'
import { ControlButtonContext } from '../context/ControlButtonContext'

/**
 * Like есть в desktop и mobile
 * 1. desktop имеет статичный background-image
 * 2. mobile не имеет background-image, но меняет цвет при scrollEvent
 * 3. scrollEvent передается только в mobile версии
 *
 */
export const Like = forwardRef<HTMLAnchorElement, { style?: CSSProperties }>(
  ({ style }, ref) => {
    const authorized = useAuthorized()
    const authorizationPath = useAuthorizationPath()

    const { hadVoted } = useContext(ProfileNextContext)
    const { onHandleClick } = useContext(ControlButtonContext)

    const handleClick = useCallback(
      (event: SyntheticEvent) => {
        if (authorized) {
          event.preventDefault()
          onHandleClick(Direction.right)
        }
      },
      [authorized, onHandleClick]
    )

    if (!authorized) {
      return (
        <Link
          ref={ref}
          to={authorizationPath}
          style={style}
          className={cx(commonCss)}
          data-name="like-action"
        >
          <HeartSvg {...iconProps} />
        </Link>
      )
    }

    return (
      <div
        ref={ref as RefObject<HTMLDivElement>}
        style={style}
        className={cx(commonCss, hadVoted && activeCss)}
        onClick={!hadVoted ? handleClick : undefined}
        data-name="like-action"
      >
        <HeartSvg {...iconProps} />
      </div>
    )
  }
)
